import { gql } from 'graphql-tag'

export const UPDATE_RENAMINGS_MUTATION = gql`
  mutation UpdateRenamings($renamings: [RenamingInputDto!]!) {
    updateRenamings(renamings: $renamings) {
      id
    }
  }
`
